import Reveal, { Eyebrow } from "./Reveal";
import { Landmark, Stethoscope, Wrench, Pill, UtensilsCrossed } from "lucide-react";

const PACKS = [
  {
    id: "collections",
    icon: Landmark,
    name: "Collections",
    tag: "Live today",
    live: true,
    body: "Verifies the right party, reminds, agrees a promise to pay, settles where allowed, and follows up broken promises.",
    span: "md:col-span-3 lg:col-span-7",
  },
  {
    id: "clinics",
    icon: Stethoscope,
    name: "Clinics",
    tag: "Configured pack",
    live: false,
    body: "AI receptionist: answers the phone, checks availability, books appointments, sends confirmation SMS.",
    span: "md:col-span-3 lg:col-span-5",
  },
  {
    id: "garages",
    icon: Wrench,
    name: "Garages & service",
    tag: "Configured pack",
    live: false,
    body: "Books service appointments, reminds customers of bookings, follows up after service.",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "pharmacies",
    icon: Pill,
    name: "Pharmacies",
    tag: "Configured pack",
    live: false,
    body: "Refill reminders and order-ready calls, with confirmation by phone or SMS.",
    span: "md:col-span-2 lg:col-span-4",
  },
  {
    id: "restaurants",
    icon: UtensilsCrossed,
    name: "Restaurants",
    tag: "Configured pack",
    live: false,
    body: "Takes orders and reservations by phone, confirms bookings, reminds guests.",
    span: "md:col-span-2 lg:col-span-4",
  },
];

const UseCases = () => (
  <section id="use-cases" data-testid="use-cases-section" className="py-20 sm:py-28 bg-white border-y border-zinc-200">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Use cases</Eyebrow>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
          One platform, configured per business.
        </h2>
        <p className="text-zinc-600 mt-6 leading-relaxed">
          Each use case is a pack configured on the same platform core. The collections pack is live
          today; other packs are configured for the business that needs them.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5 mt-14">
        {PACKS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.07} className={p.span}>
            <div
              data-testid={`use-case-card-${p.id}`}
              className="group relative h-full bg-[#FAF9F6] border border-zinc-200 rounded-2xl p-7 sm:p-8 overflow-hidden hover:border-[#09090B] hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(9,9,11,0.25)] transition-all duration-500"
            >
              <div className="flex items-start justify-between">
                <p.icon size={26} className="text-[#2563EB] transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6" />
                <span
                  className={`font-mono2 text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full ${
                    p.live ? "bg-[#2563EB] text-white" : "bg-zinc-200/70 text-zinc-500"
                  }`}
                >
                  {p.live && <span className="inline-block w-1.5 h-1.5 rounded-full bg-white mr-1.5 blink-dot" />}
                  {p.tag}
                </span>
              </div>
              <h3 className="font-display font-bold text-xl sm:text-2xl mt-6 text-zinc-900">{p.name}</h3>
              <p className="text-zinc-600 mt-2.5 text-sm sm:text-base leading-relaxed">{p.body}</p>
              {p.live && (
                <button
                  data-testid="use-case-collections-link"
                  onClick={() => document.querySelector("#collections")?.scrollIntoView({ behavior: "smooth" })}
                  className="mt-5 text-sm font-medium text-[#2563EB] inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all duration-300"
                >
                  See the live pack →
                </button>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default UseCases;
